<div class="card card-danger">
  <div class="card-header">
    <div class="float-left"><h5> Rate Cards </h5></div>
    <div class="float-right">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button (click)="showFind()" type="button" class="btn btn-sm btn-outline-info"><i class="fa fa-search" aria-hidden="true"></i> Find</button>
        <button (click)="showNew()" type="button" class="btn btn-sm btn-outline-success"><i class="fa fa-plus" aria-hidden="true"></i> Add new </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="row">
      <div class="col">

        <div *ngIf="mode==formModes.Find">
          <div class="row" style="margin-left: 0px;">
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="Name" class="col-sm-3 col-form-label" style="position: relative; top: 6px;">Name</label>
                <div class="col-sm-9" style="margin-left: -64px; height: 0px;">
                  <!-- <input [(ngModel)]="rateFileName" maxlength="50" class="form-control form-control-sm" #name="ngModel" type="text" id="Name" name="Name"/> -->
                  <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input matInput [(ngModel)]="rateFileName" maxlength="50" #name="ngModel" type="text" id="Name" name="Name" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12" style="position: relative; top: 16px;">
              <div class="text-center m-3">
                <button type="button" (click)="onSubmit()" class="btn btn-sm btn-info mx-1"><i class="fa fa-search" aria-hidden="true"></i> Search </button>
                <button type="button" class="btn btn-sm btn-outline-secondary mx-1" style="color: white; background-color: #2f72ab;" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
              </div>
              <br />
            </div>
          </div>
        </div>

        <div *ngIf="mode==formModes.New || mode==formModes.Edit" style="margin-left: 80px;">
          <form #f="ngForm" (ngSubmit)="onSubmit(f)">
            <div class="row" style="margin-right: -41px">
              <div class="col-sm-6">

                <div class="form-group row">
                  <label for="Label" class="col-sm-3 col-form-label">Label</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>Label</mat-label>
                      <input matInput [(ngModel)]="model.label" required maxlength="50" #label="ngModel" type="text" id="label" name="label">
                    </mat-form-field>
                    <div *ngIf="label.invalid && (label.dirty && label.touched)" class="text-danger small">
                      <div *ngIf="label.errors.required">
                        Label is required.
                      </div>
                      <div *ngIf="label.errors.maxlength">
                        Label must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>


                <div class="form-group row">
                  <label for="Label" class="col-sm-3 col-form-label">Carrier</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>Carrier</mat-label>
                      <mat-select [(ngModel)]="model.carrierCode" id="carrierCode" name="carrierCode" [disabled]="mode==formModes.Edit">
                        <mat-option *ngFor="let carrier of carriers" [value]="carrier.value">
                          {{carrier.label}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">

                <ng-container *ngIf="mode==formModes.Edit">
                  <div class="form-group row">
                    <label for="Name" class="col-sm-3 col-form-label">Name</label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Name</mat-label>
                        <input matInput [(ngModel)]="model.fileOriginalName" disabled #name="ngModel" type="text" id="name" name="name">
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="Label" class="col-sm-3 col-form-label">Version</label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Version</mat-label>
                        <input matInput [(ngModel)]="model.fileVersion" disabled #fileVersion="ngModel" type="text" id="fileVersion" name="fileVersion">
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="Uploaded on" class="col-sm-3 col-form-label">Uploaded on</label>
                    <div class="col-sm-9">
                      <mat-form-field appearance="outline">
                        <mat-label>Uploaded on</mat-label>
                        <input matInput [(ngModel)]="model.uploadedOn" disabled #uploadedOn="ngModel" type="text" id="uploadedOn" name="uploadedOn">
                      </mat-form-field>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="mode==formModes.New">
                  <div class="form-group row">
                    <label for="myfile" class="col-sm-3 col-form-label">Upload rate file</label>
                    <div class="col-sm-9">
                      <p-fileUpload [showUploadButton]="true"
                                    (change)="upload($event)"
                                    (onUpload)="onUploadComplete($event)"
                                    (onBeforeSend)="onBeforeSendFile($event)"
                                    (onBeforeUpload)="onBeforeUpload($event)"
                                    (onSelect)="dealWithFiles($event)"
                                    (onError)="onUploadError($event)"
                                    name="myfile"
                                    url="{{CarrierInvoiceFileControllerUrl}}"
                                    accept=".xlsx, .xls,"
                                    maxFileSize="2147483647"
                                    [showCancelButton]="false">
                      </p-fileUpload>
                    </div>
                  </div>
                </ng-container>

              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="text-center m-3">
                  <!--<button type="button" (click)="showMappingsModal()" *ngIf="this.isRateFileButtonDisplay == true" class="btn btn-sm btn-info mx-1"> <i class="fa fa-file-excel-o" aria-hidden="true"></i> Map Carrier Rate Files</button>-->
                  <!--<button type="submit" [disabled]="f.invalid" *ngIf="mode==formModes.New" class="btn btn-sm btn-success mx-1"><i class="fa fa-plus" aria-hidden="true"></i> Save </button>-->
                  <button type="submit" [disabled]="f.invalid" *ngIf="mode==formModes.Edit" class="btn btn-sm mx-1" style="color: white; background-color: #2f72ab;"><i class="fa fa-floppy-o" aria-hidden="true"></i> Update </button>
                  <button type="button" class="btn btn-sm btn-outline-secondary mx-1" style="color: white; background-color: #2f72ab;" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
                  <a href="{{CarrierInvoiceFileControllerUrl}}/{{model.id}}?action=download" target="_blank" class="btn btn-sm btn-outline-success"><i class="fa fa-cloud-download" aria-hidden="true"></i> Download</a>
                  <button type="button" (click)="viewRateFile(model)" class="btn btn-sm btn-outline-primary"><i class="fa fa-eye" aria-hidden="true"></i> View</button>
                </div>
                <br />
              </div>
            </div>
          </form>
        </div>

        <div *ngIf="mode==formModes.Del">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="Name" class="col-sm-3 col-form-label">Name</label>
                <div class="col-sm-9">
                  <mat-form-field appearance="outline">
                    <mat-label>Enter your name</mat-label>
                    <input matInput [(ngModel)]="model.name" required maxlength="50" #name="ngModel" type="text" id="Name" name="Name" [readonly]="true">
                  </mat-form-field>
                  <div *ngIf="name.invalid && (name.dirty && name.touched)" class="text-danger small">
                    <div *ngIf="name.errors.required">
                      Name is required.
                    </div>
                    <div *ngIf="name.errors.maxlength">
                      Name must be less than 50 characters long.
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="text-center m-3">
                <button type="button" (click)="onSubmit()" class="btn btn-sm btn-danger mx-1"><i class="fa fa-times" aria-hidden="true"></i> Delete </button>
                <button type="button" (click)="resetForm()" style="color: white; background-color: #2f72ab;" class="btn btn-sm mx-1"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
              </div>
              <br />
            </div>
          </div>
        </div>

      </div>
    </div>

    <div *ngIf="mode != formModes.New && mode != formModes.Edit" class="row">
      <div class="col">

        <div class="mat-elevation-z8">
          <table mat-table [dataSource]="RateFiledataSource">

            <!-- <ng-container matColumnDef="Id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Id </th>
              <td mat-cell *matCellDef="let row">{{ row.id }}  </td>
            </ng-container> -->

            <ng-container matColumnDef="Carrier">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Carrier </th>
              <td mat-cell *matCellDef="let row"> {{ row.carrierCode }} </td>
            </ng-container>

            <ng-container matColumnDef="Label">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Label </th>
              <td mat-cell *matCellDef="let row"> {{ row.label }} </td>
            </ng-container>
            <ng-container matColumnDef="UploadedOn">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded On </th>
              <td mat-cell *matCellDef="let row"> {{ row.uploadedOn }} </td>
            </ng-container>
            <ng-container matColumnDef="Actions">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ... </th>
              <td mat-cell *matCellDef="let row">
                <button (click)="showEdit(row)" class="btn btn-sm btn-outline-primary"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                <button (click)="delete(row)" class="btn btn-sm btn-outline-danger"><i class="fa fa-times" aria-hidden="true"></i></button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


          </table>
          <!--<tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">There is no record</td>
          </tr>-->
          <span style="position: relative; left: 40%; font-size: 13px; top: 40px;">There are {{this.tabledata?.length}} records</span>
          <mat-paginator [length]="this.tabledata?.length" [pageSizeOptions]="[5, 10,50, 100]" aria-label="Select page of users" (page)="onChangedPageSize($event)"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #showcarrierratesPopup>
  <div style="width: 590px; height: 500px; overflow-x: auto; overflow-y: auto; ">
    <mat-dialog-content style="display: flex; justify-content: end;">
      <button mat-flat-button class="close-icon" (click)="close()">
        <mat-icon style="margin-right: -30px;">close</mat-icon>
      </button>
    </mat-dialog-content>
    <p-header style=" margin-left: 30px;">View Rates for {{model.label}}</p-header>

    <div>
      <div class="row" style=" width: 586px; margin-left: 2px; margin-right: 2px;">
        <div>
          <div class="mat-elevation-z8">
            <table mat-table [dataSource]="this.CarrierRateColArray" matSort>
              <ng-container matColumnDef="{{column}}" *ngFor="let column of this.CarrierRateColArray; let k = index;">
                <th mat-header-cell *matHeaderCellDef> {{column}} </th>
                <div>
                  <td mat-cell *matCellDef="let element; let i= index">
                    <div *ngIf="i < this.CarrierRateArray?.length">
                      {{this.CarrierRateArray[i][k]}}
                    </div>
                  </td>
                </div>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="this.CarrierRateColArray"></tr>
              <tr mat-row *matRowDef="let element; columns: this.CarrierRateColArray;"></tr>
            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
